import { render, staticRenderFns } from "./CollectionsByCategoryWidget.vue?vue&type=template&id=7433fa2c&scoped=true&"
import script from "./CollectionsByCategoryWidget.vue?vue&type=script&lang=js&"
export * from "./CollectionsByCategoryWidget.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsByCategoryWidget.vue?vue&type=style&index=0&id=7433fa2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7433fa2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
